export const STATUS_STYLES = {
  New: "bg-[#ff9933]/15 text-[#a85400]",
  Contacted: "bg-sky-100 text-sky-800",
  "Matches Sent": "bg-violet-100 text-violet-800",
  "Visit Planned": "bg-amber-100 text-amber-800",
  Closed: "bg-[#138808]/15 text-[#0f6d06]",
  "Not Interested": "bg-neutral-200 text-neutral-600",
};

export const StatusBadge = ({ status, testId }) => (
  <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_STYLES[status] || ""}`} data-testid={testId}>
    {status}
  </span>
);

export const whatsappLink = (lead, staffName) => {
  const first = lead.contact.name.split(" ")[0];
  const where = lead.answers.city && lead.answers.city !== "Not decided yet" ? ` in ${lead.answers.city}` : " in India";
  const text = `Namaste ${first}, this is ${staffName} from PropertiesforNRI.com. Thank you for sharing your requirement for a ${lead.answers.property_type.toLowerCase()}${where}. We're preparing your matches and will share everything here on WhatsApp chat.`;
  return `https://wa.me/${lead.contact.phone_e164.replace("+", "")}?text=${encodeURIComponent(text)}`;
};

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const Card = ({ children, className = "", ...p }) => (
  <div className={`rounded-2xl border border-neutral-200 bg-white p-5 ${className}`} {...p}>{children}</div>
);

export const PageTitle = ({ children, right }) => (
  <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
    <h1 className="font-display text-3xl text-[#1f2328]">{children}</h1>
    {right}
  </div>
);

export const ReadyBadge = ({ badge, testId }) => {
  if (!badge) return null;
  const pending = badge.email_pending || badge.wa_pending;
  if (!badge.ready) return <span className="inline-flex items-center gap-1 rounded-full bg-[#FF9933]/15 px-2 py-0.5 text-[11px] font-semibold text-[#a35400]" data-testid={testId}>Preparing {badge.total} presentation{badge.total === 1 ? "" : "s"}</span>;
  if (!pending) return <span className="inline-flex items-center gap-1 rounded-full bg-neutral-100 px-2 py-0.5 text-[11px] font-semibold text-neutral-600" data-testid={testId}>✓ {badge.ready}/{badge.total} shared</span>;
  const todo = [badge.wa_pending && "WhatsApp", badge.email_pending && "email"].filter(Boolean).join(" & ");
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-[#138808] px-2.5 py-0.5 text-[11px] font-semibold text-white" data-testid={testId}>
      <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-white" /> {badge.ready} ready · send on {todo}
    </span>
  );
};
